// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cb3e08e3","455":"85b9e9d7"}[chunkId] + ".chunk.js";
};